import { writable } from 'svelte/store';

const databaseData = writable({ 
    all: [],
    wpn_id: "", 
    user_login_email: "",
    user_item: {},
    utility_item: {},
    modifications: {
        created: [],
        deleted: [],
        updated: []
    },
    alfx_data: {},
});

const dbData = {
    subscribe: databaseData.subscribe,
    addOrReplaceItem: (item) => {
        databaseData.update( (x) => {
            const eName = item.entity;
            var allItems = x.all[eName] ?? [];
            // 1. Add or replace in database
            const indexDB = allItems.findIndex((element) => element['uuid'] == item['uuid'] );
            if (indexDB >= 0) {
                allItems[indexDB] = item;
            } else {
                allItems.push(item);
            }
            x.all[eName] = allItems;
            // 2. Add or replace in modifications
            var mods = x.modifications.updated ?? [];
            const indexMods = mods.findIndex((element) => element['uuid'] == item['uuid'] );
            if (indexMods >= 0) {
                mods[indexMods] = item;
            } else {
                mods.push(item);
            }
            x.modifications.updated = mods;
            return x;
        });
    },
    setDatabase: (dataDB) => {
        databaseData.update( (x) => {
            x.all = dataDB;
            return x;
        });
    },
    setWPNID: (wpnID) => {
        databaseData.update( (x) => {
            x.wpn_id = wpnID;
            return x;
        })
    },
    setUtility: (utility) => {
        databaseData.update( (x) => {
            x.utility_item = utility;
            return x;
        })
    },
    setUser: (user_item) => {
        databaseData.update( (x) => {
            x.user_item = user_item;
            return x;
        })
    },
    setLoginEmail: (loginEmail) => {
        databaseData.update( (x) => {
            x.user_login_email = loginEmail;
            return x;
        })
    },
    setALFXData: (alfxData) => {
        const eName = Object.keys(alfxData)[0];
        databaseData.update((x) => {
            x.alfx_data[eName] = alfxData[eName];
            return x;
        });
    },
    clearAllALFXData: () => {
        databaseData.update((x) => {
            x.alfx_data = {};
            return x;
        });
    },
    emptyUpdatesStore: () => {
        databaseData.update( (x) => {
            x.modifications.created = [];
            x.modifications.deleted = [];
            x.modifications.updated = [];
            return x;
        });
    }
};
export default dbData;